import { toast } from "react-toastify"
import BASE_URL from "./apiConfig"

const GetAPI = async (url, headersObj = {}) => {
  url = `${BASE_URL}/api/${url}`
  const token = localStorage.getItem("authUser")

  // Ensure token is not null or undefined
  let tokenid = ""
  if (token) {
    try {
      const parsedToken = JSON.parse(token)
      tokenid = parsedToken?.access_token || ""
    } catch (error) {
      console.error("Error parsing token:", error)
    }
  }

  // Add Authorization header if token exists
  const headers = tokenid
    ? { ...headersObj, Authorization: `Bearer ${tokenid}` }
    : headersObj

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    })
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || "An unknown error occurred")
    }
    return await response.json()
  } catch (error) {
    // Handle error appropriately
    toast.error(error.messages[0].message)
    return { error: error.message || "An unknown error occurred" }
  }
}

export default { GetAPI }
